import { UserResponse, UserRole } from './../../entities/account/UserResponse';

export function isAdmin(user?: UserResponse | null) {
  return user ? user.role === UserRole.admin : false;
}

export function isStaff(user?: UserResponse | null) {
  return user ? user.role === UserRole.admin || user.role === UserRole.user : false;
}

export function isClient(user?: UserResponse | null) {
  return user ? user.role === UserRole.client : false;
}
